var Secretaria = (function () {
    function Secretaria(secId, descCorta, descripcion) {
        this.secId = secId;
        this.descCorta = descCorta;
        this.descripcion = descripcion;
    }
    return Secretaria;
}());
export { Secretaria };
//# sourceMappingURL=secretaria.js.map